import { apiFetcher } from '@gjensidige/service-async';
import { remoteLogMessage } from '@gjensidige/service-error-handler';

import {
  CarPaperClaimForm,
  CountRequest,
  EquinorAccident,
  EquinorDeath,
  EquinorTravelValues,
  FormType,
  SportInjury,
} from '../utils/types';

export const postCarPaperForm = async (body: CarPaperClaimForm): Promise<string> => {
  const response = await apiFetcher.post(
    '/claims-openpages-forms-api/api/request-car-paper-claim-form',
    {
      body,
    },
  );

  if (response.isOk()) {
    return response.value;
  }
  throw response.error;
};

export const postSportInjuryUihs = async (body: SportInjury): Promise<string> => {
  const response = await apiFetcher.post(
    '/claims-openpages-forms-api/api/report-sport-injury-uihs',
    {
      body,
    },
  );

  if (response.isOk()) {
    return response.value;
  }
  throw response.error;
};

export const postSportInjury = async (body: SportInjury): Promise<string> => {
  const response = await apiFetcher.post('/claims-openpages-forms-api/api/report-sport-injury', {
    body,
  });

  if (response.isOk()) {
    return response.value;
  }
  throw response.error;
};

export const postEquinorAccident = async (body: EquinorAccident): Promise<string> => {
  const response = await apiFetcher.post(
    '/claims-openpages-forms-api/api/report-equinor-accident',
    {
      body,
    },
  );

  if (response.isOk()) {
    return response.value;
  }
  throw response.error;
};

export const postEquinorDeath = async (body: EquinorDeath): Promise<string> => {
  const response = await apiFetcher.post('/claims-openpages-forms-api/api/report-death', {
    body,
  });

  if (response.isOk()) {
    return response.value;
  }
  throw response.error;
};

export const postEquinorTravelForm = async (
  body: EquinorTravelValues,
  formType: FormType,
): Promise<string> => {
  const response = await apiFetcher.post(
    `/claims-openpages-forms-api/api/report-equinor-travel?formType=${formType}`,
    {
      body,
    },
  );
  if (response.isOk()) {
    return response.value;
  }
  throw response.error;
};

export const postFormStartedCount = async (body: CountRequest): Promise<string> => {
  const response = await apiFetcher.post(`/claims-openpages-forms-api/api/count`, {
    body,
  });
  if (response.isOk()) {
    return response.value;
  } else {
    remoteLogMessage('error starting counter', { severity: 'INFO' });
    return response.error.message;
  }
};
